import qs from "querystringify";
import _ from "lodash";

export const updateLinkQuery = (router, queryUpdater) => {
  const [pathname, queryString = ""] = router.asPath.split("?");
  const query = qs.parse(queryString);
  queryUpdater(query);
  const newQueryString = qs.stringify(query);

  return {
    href: [router.pathname, newQueryString].filter((x) => x).join("?"),
    as: [pathname, newQueryString].filter((x) => x).join("?"),
  };
};

export const userUrl = (user, currentUser = null) => {
  if (!user) {
    return null;
  }
  const isCurrentUser = currentUser && currentUser.id === user.id;
  return isCurrentUser ? "/profile/info" : `/users/${user.id}`;
};

export const postUrl = (post) => {
  return post.category_code === "talent" ||
    (post.category && post.category.code === "talent")
    ? `/tposts/${post.id}`
    : `/posts/${post.id}`;
};

// /tposts/[id] re-exports the posts detail page, so reconstructed URLs
// must follow the matched route rather than assuming /posts.
export const postPagePath = (pathname, id) => {
  const prefix = pathname?.includes("tposts") ? "tposts" : "posts";
  return `/${prefix}/${id}`;
};

export const postEditUrl = (post) => {
  return `${postUrl(post)}/edit`;
};

export const postNewUrl = (post) => {
  const isJob = post.category.kind === "work";
  const baseUrl = isJob ? "/jobs/new" : "/posts/new";
  return `${baseUrl}?original_id=${post.id}&c=${post.category.code}`;
};

export const getHref = (post) => {
  return post.category_code === "talent" ||
    (post.category && post.category.code === "talent")
    ? "/tposts/[id]"
    : "/posts/[id]";
};

export const userPostsUrl = (user, params = {}) => {
  return `/users/${user.id}${qs.stringify(params, true)}`;
};

export const userProfileUrl = (user) => {
  return `/users/${user.id}/profile`;
};

export const buildCategoryUrl = (categoryId, path = "/categories") => {
  if (categoryId === "follows") {
    return {
      href: "/follows",
      as: "/follows",
    };
  } else if (categoryId === "all") {
    return {
      href: "/",
      as: "/",
    };
  } else if (categoryId) {
    return {
      href: `${path}/[category]`,
      as: `${path}/${categoryId}`,
    };
  } else {
    return {
      href: "/",
      as: "/",
    };
  }
};
